import { RouteName } from "constant/route"

export function getMarketDetailUrl(base: string, quote: string) {
    return RouteName.MARKET_DETAIL.replace(":base", base).replace(":quote", quote)
}

export function getPoolDetailUrl(base: string, quote: string) {
    return RouteName.POOL_DETAIL.replace(":base", base).replace(":quote", quote)
}
